import request from '@/utils/request'

// 获取门禁列表（运营端）
export function listAdminAccessControl(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/iot.listAdminAccessControl',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const listData = res.data
        resolve({
          data: listData.machineDtos || listData.records || [],
          total: listData.total || res.total || 0
        })
      } else {
        reject(new Error(res.msg || '获取门禁列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存设备
export function saveMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/machine.saveMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存设备失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新设备
export function updateMachine(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/machine.updateMachine',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新设备失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取管理员小区列表（运营端）
export function listAdminCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listAdminCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
          total: res.total
        })
      } else {
        reject(new Error(res.msg || '获取小区列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
